"use client";

import * as React from "react";
import { useAutosizeTextArea } from "./autosize-textarea";
import { Button } from "@/components/ui/button";

// This example demonstrates using the useAutosizeTextArea hook directly
// In a real app, you could use this with react-hook-form or other form libraries
export function AutosizeTextareaCustomDemo() {
  const [value, setValue] = React.useState("");
  const textAreaRef = React.useRef<HTMLTextAreaElement>(null);

  // Use the hook directly with our own textarea
  useAutosizeTextArea({
    textAreaRef: textAreaRef,
    triggerAutoSize: value,
    maxHeight: 250,
    minHeight: 60,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Submitted value: ${value}`);
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-sm space-y-4">
      <div className="space-y-2">
        <label htmlFor="custom-textarea" className="text-sm font-medium">
          Custom Textarea
        </label>
        <textarea
          ref={textAreaRef}
          id="custom-textarea"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Type something..."
          className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        />
        <p className="text-xs text-muted-foreground">
          This uses the hook directly for more customization
        </p>
      </div>

      <Button type="submit">Submit</Button>
    </form>
  );
}
